import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
    selector: 'ts-protocol-header',
    templateUrl: './protocol-header.component.html',
    styleUrls: ['./protocol-header.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ProtocolHeaderComponent {
  @Input() name: string;
  @Input() count: number;
  @Input() total: number;
  @Input() changeCount: number;
  @Input() loading = true;

  public get percentage() {
    return this.count > 0 ? (this.count / this.total) * 100 : 0;
  }
}
